export const TOKEN_REFRESH_THRESHOLD_SECONDS = 120;
export const TOKEN_REFRESH_INTERVAL = 60000;
export const TOKEN_RETRY_DELAY_MS = 3000;
export const MAX_TOKEN_RETRY_ATTEMPTS = 3;
